module.exports = __webpack_public_path__ + "img/app store logo_new.2de0d431.svg";